let Components = {};

var req = require.context('./Animations', true, /\.js$/);
for (let i = 0; i < req.keys().length; i++) {
    var key = req.keys()[i];
    key = key.substring(2, key.length);
    var keyname = key.split('/')[1];
    try {
        Components[keyname.substring(0, keyname.length - 3)] = require('./Animations/' + key).default;
    }
    catch (error) {
        console.log("");
    }
}

export default Components